
import { Flex } from "@similarweb/ui-components/foundations";

import { multiIncludeExcludeType } from "app/components/multi-include-exclude-filter/consts";
import { MultiIncludeExcludeFilterContainer } from "app/components/multi-include-exclude-filter/MultiIncludeExcludeFilterContainer";

import { TrendsFilter } from "./trends/TrendsFilter";

export const TopicsFilters = () => {
    return (
        <Flex
            flexDirection="row"
            gap="16px"
            margin="0 0 16px 0"
        >
            <Flex flexGrow={0}>
                <MultiIncludeExcludeFilterContainer filterType={multiIncludeExcludeType.TOPIC} />
            </Flex>
            <Flex flexGrow={0}>
                <TrendsFilter />
            </Flex>
        </Flex>
    );
};
